import { createGameUIInstances, GameUI } from './gameUI';
import { Notification } from '../../../notification/notfication';
import Axios from '../../../../../../../../node_modules/axios';
import { Search } from './search';

class Game {
  public constructor(private ui: GameUI) {
    this.ui.onSubmit(this.submit.bind(this));
    this.ui.onOpenSelect(this.block.bind(this));
  }

  private submit() {
    this.ui.loading(true);
    this.ui.disableButton();
    if (this.ui.getSlots() === '0') {
      this.ui.loading(false);
      new Notification('danger', 'Oops.', 'Please select slot size from the menu');
      this.ui.enableButton();
      return;
    }
    const bodyFormData = new FormData();
    bodyFormData.append('orderId', this.ui.getOrderId());
    bodyFormData.append('serverId', this.ui.getServerId());
    bodyFormData.append('units', this.ui.getSlots());

    Axios.post(`${window.basePath + window.regionPrefix}/gamecloud/addServerToCloud`, bodyFormData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest',
      },
    }).then((response) => {
      if (response.data.result === 'error') {
        if (response.data.message !== undefined) {
          new Notification('danger', 'Oops', response.data.message);
        } else {
          new Notification('danger', 'Oops', 'Something went wrong');
        }

        window.setTimeout(() => {
          window.location.href = `${window.basePath + window.regionPrefix}/gamecloud`;
        }, 2000);
      } else {
        new Notification('success', 'Done', 'Your order is complete. You will redirect in few seconds.');

        window.setTimeout(() => {
          window.location.href = `${window.basePath + window.regionPrefix}/gamecloud#${response.data.serverId}`;
        }, 2000);
      }

      this.ui.loading(false);
    });
  }

  private block() {
    this.ui.unblockAll();
    this.ui.block();
  }
}

export function initGame() {
  new Search();

  return createGameUIInstances().map((ui: GameUI) => new Game(ui));
}
